<template>
  <button
    :class="[
      'base-button',
      isCancel ? 'cancel' : 'principal',
      isFilter ? 'filter' : '',
      isDisabled ? 'disabled' : '',
      isSelected ? 'selected' : '',
    ]"
    :disabled="isDisabled"
  >
    {{ buttonLabel }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "StandardButton",
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isCancel: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: "Botón",
    },
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/standardButton";
</style>
